import axios from 'axios';
import authToken from 'js/library/utils/API/authToken';
import cfac22 from '../cfac22';

export default function getFeedPosts(uId, keywords, orgs, relationships, dateLimit, limit) {
  return new Promise((resolve, reject) => {
    authToken(uId)
      .then((token) => {
        axios
          .post(
            // eslint-disable-next-line no-undef
            `${cfac22('API_HOST_V2')}/feedPosts`,
            {
              keywords,
              orgs,
              relationships,
              dateLimit,
              limit,
            },
            { headers: { authorization: `Bearer ${token}`, 'Full-Url': window.location.href } }
          )
          .then((result) => {
            // console.log("RESULT_GetFeedPosts: ", result);
            resolve(result.data);
          })
          .catch((error) => {
            //console.log("ERROR_GetFeedPosts: ", error);
            return reject(error);
          });
      })
      .catch((error) => {
        //console.log("ERROR_TOKE:", error);
        reject(error);
      });
  });
}
